import { FetchBase } from '../shared/FetchBase'

export interface IServerTimeResponse {
    utcTime: string; // Use string for dates in JSON responses
    utcOffset: number;
    timeZoneId: string;
    timeZoneDisplay: string;
}

export class HomeFetch extends FetchBase {
  constructor() {
    super('', '/api/home')
  }
}
